(function(){
'use strict';
var T=(window.MDS_T)||{cart:{},p:{},a:{},g:{},c:{}};
var EN_JS={
 'cart.empty':'Your bag is empty.','cart.see_collection':'See the collection','cart.remove':'Remove',
 'cart.subtotal':'Subtotal','cart.shipping':'Shipping','cart.complimentary':'Calculated at checkout',
 'cart.total':'Total','cart.checkout':'Checkout','cart.methods':'Available payment methods shown at checkout',
 'product.add':'Add to bag','product.sold_out':'Sold out','product.unavailable':'Unavailable',
 'product.adding':'Adding…','product.variant_sold_out':'This variant is sold out. Write to us and we will make it to order.',
 'appointment.title':'Private appointment','appointment.sub':'Rua de Damão 109, Alcabideche · measurements take twenty minutes',
 'appointment.subject':'Subject','appointment.what':'What you have in mind — occasion, piece, timing',
 'appointment.note':'For bespoke and made-to-order above €1,500 the visit is required: feet cannot be measured remotely.',
 'appointment.cta':'Request appointment','general.name':'First name','general.phone':'Phone','general.email':'Email',
 'configurator.choose_size':'Choose a size.'};
function tr(key,fallback){ if(T._lang==='en'&&EN_JS[key])return EN_JS[key]; return fallback||''; }
var LOC=(T.locale||'pt').indexOf('en')===0?'en-GB':'pt-PT';
var LEATHERS=[{k:'oceano',n:'Azul noite',c:'#293A51',s:'#1B2839',add:0},
 {k:'ebano',n:'Preto',c:'#262423',s:'#171616',add:0},
 {k:'bordo',n:'Bordô',c:'#7A373E',s:'#592A31',add:0},
 {k:'cognac',n:'Conhaque',c:'#995C31',s:'#704221',add:0},
 {k:'verde',n:'Verde escuro',c:'#314B38',s:'#203329',add:0}];
var MATS=[{k:'vitela',n:'Vitela',add:0},{k:'camurca',n:'Camurça',add:140},{k:'cordovan',n:'Cordovan',add:420},{k:'marinho',n:'Fibra marinha',add:220}];
var SOLES=[{k:'couro',n:'Couro',add:0},{k:'borracha',n:'Borracha natural',add:90}];
var DETAILS=[{k:'no',n:'Nó de pescador',add:0},{k:'franja',n:'Franja',add:80},{k:'liso',n:'Liso',add:0},{k:'mono',n:'Monograma gravado',add:160}];
var NAV_DETAILS=[{k:'gold',n:'Dourado',add:0},{k:'silver',n:'Prateado',add:0},{k:'bronze',n:'Bronze',add:0},{k:'liso',n:'Sem adorno',add:0}];
var REIS_DETAILS=[{k:'gold',n:'Dourado',add:0},{k:'silver',n:'Prateado',add:0},{k:'bronze',n:'Bronze',add:0}];
var SIZES=['35','36','37','38','39','40','41','42','43','44','45'];
var S={leather:'cognac',mat:'vitela',sole:'couro',detail:'no',size:null,base:0};
var THREE_VIEW=null;

function money(n){try{return new Intl.NumberFormat(LOC,{style:'currency',currency:'EUR',maximumFractionDigits:0}).format(n)}catch(e){return n+' €'}}
function cents(c){return money(Math.round(c)/100)}
function find(a,k){for(var i=0;i<a.length;i++){if(a[i].k===k)return a[i]}return a[0]}

/* ---------- configurador ---------- */
function shoe(){
  var L=find(LEATHERS,S.leather), sole=S.sole==='borracha'?'#2B2723':'#6E5540', suede=S.mat==='camurca'?.24:0, x='';
  if(S.detail==='franja'){for(var i=0;i<7;i++){x+='<rect x="'+(262+i*20)+'" y="118" width="13" height="30" rx="6"/>'}x='<g fill="'+L.c+'">'+x+'</g>'}
  var knot=S.detail==='no'?'<g stroke="#EDE4D4" stroke-width="5" fill="none" opacity=".92" stroke-linecap="round"><path d="M300 128C316 112 344 112 358 128s-.5 30-18 24c-18-6-24-22-8-30s34 2 36 16"/><path d="M292 142c18-8 44-6 60 4"/></g>':'';
  var mono=S.detail==='mono'?'<text x="332" y="148" font-family="Georgia,serif" font-size="30" fill="#F4EBD8" opacity=".55">DS</text>':'';
  return '<svg viewBox="0 0 520 300" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Pré-visualização do par"><defs>'+
   '<linearGradient id="up" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="'+L.c+'"/><stop offset="1" stop-color="'+L.s+'"/></linearGradient>'+
   '<linearGradient id="sh" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#fff" stop-opacity="'+(0.3-suede)+'"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient>'+
   '<filter id="soft"><feGaussianBlur stdDeviation="5"/></filter></defs>'+
   '<ellipse cx="262" cy="262" rx="200" ry="12" fill="#1A1613" opacity=".15" filter="url(#soft)"/>'+
   '<path d="M70 232C60 186 86 150 132 136c44-14 74-18 114-32 46-16 84-30 126-22 48 9 76 44 80 86 4 38-16 64-50 70-72 12-252 12-332-6Z" fill="url(#up)"/>'+
   '<path d="M70 232C60 186 86 150 132 136c44-14 74-18 114-32 46-16 84-30 126-22 48 9 76 44 80 86 4 38-16 64-50 70-72 12-252 12-332-6Z" fill="url(#sh)"/>'+
   '<path d="M238 110c34 18 62 30 106 32 40 2 66-6 84-18-8-18-30-34-56-40-40-8-80 6-134 26Z" fill="'+L.s+'" opacity=".72"/>'+
   x+knot+mono+
   '<path d="M64 234c86 20 276 20 342 6 32-7 46-14 50-26 4 18-12 38-52 44-74 12-262 10-338-8Z" fill="'+sole+'"/>'+
   '<path d="M78 236c82 16 252 16 322 4" stroke="#F2E9D8" stroke-width="2" fill="none" opacity=".45" stroke-dasharray="5 7"/></svg>';
}
function supp(){return find(LEATHERS,S.leather).add+find(MATS,S.mat).add+find(SOLES,S.sole).add+find(DETAILS,S.detail).add}
function paint(){
  var el=document.getElementById('shoe'); if(!el)return;
  el.innerHTML=shoe();
  var t=document.getElementById('cfgtotal'); if(t)t.textContent=money(S.base+supp());
  var set=function(id,v){var e=document.getElementById(id); if(e)e.value=v};
  set('p-leather',find(LEATHERS,S.leather).n); set('p-mat',find(MATS,S.mat).n);
  set('p-sole',find(SOLES,S.sole).n); set('p-detail',find(DETAILS,S.detail).n);
  set('p-size',S.size||''); set('p-supp',money(supp()));
  if(THREE_VIEW)THREE_VIEW.update(S);
  if(window.MDS2D&&window.MDS2D.refresh)window.MDS2D.refresh(S);
}

/* ---------- visor 3D: malha própria de loafer, inspirada nas fotografias reais ---------- */
function init3D(hostId){
  var host=document.getElementById(hostId||'shoe-3d'); if(!host)return;
  if(hostId==='product-shoe-3d'){S.leather='oceano';S.mat='vitela';S.sole='couro';S.detail='no'}
  var photoFallback=host.querySelector('img');
  var load=import('https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js');
  load.then(function(THREE){
    var scene=new THREE.Scene(), camera=new THREE.PerspectiveCamera(32,1,.1,100);
    camera.position.set(2.4,2.7,9.2); camera.lookAt(0,.42,0);
    var renderer=new THREE.WebGLRenderer({alpha:true,antialias:true,powerPreference:'high-performance'}); renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,2)); renderer.outputColorSpace=THREE.SRGBColorSpace; renderer.toneMapping=THREE.ACESFilmicToneMapping; renderer.toneMappingExposure=1.05; renderer.shadowMap.enabled=true;renderer.shadowMap.type=THREE.PCFSoftShadowMap; host.innerHTML=''; host.appendChild(renderer.domElement);
    var group=new THREE.Group(); group.rotation.y=-.38; scene.add(group);
    scene.add(new THREE.HemisphereLight(0xfff9ef,0x172033,2.05));
    var key=new THREE.DirectionalLight(0xfff4e5,3.5); key.position.set(2.5,6,5);key.castShadow=true;key.shadow.mapSize.set(1536,1536);key.shadow.camera.left=-6;key.shadow.camera.right=6;key.shadow.camera.top=4;key.shadow.camera.bottom=-4; scene.add(key);
    var fill=new THREE.DirectionalLight(0xffffff,1.3); fill.position.set(1,3,-5); scene.add(fill);
    var rim=new THREE.DirectionalLight(0xa98b4a,1.6); rim.position.set(-4,3,2); scene.add(rim);
    var upperMat=new THREE.MeshPhysicalMaterial({color:0x2e3c4e,roughness:.34,metalness:0,clearcoat:.16,clearcoatRoughness:.42});
    var vampMat=upperMat.clone(), liningMat=new THREE.MeshStandardMaterial({color:0x171719,roughness:.82}),
        soleMat=new THREE.MeshStandardMaterial({color:0x755c43,roughness:.5}), weltMat=new THREE.MeshStandardMaterial({color:0xb79972,roughness:.68}),
        stitchMat=new THREE.MeshStandardMaterial({color:0xd5c4a6,roughness:.8}), goldMat=new THREE.MeshStandardMaterial({color:0xa98b4a,roughness:.25,metalness:.72});
    /* Very fine natural grain keeps the calfskin from reading as smooth plastic. */
    var grainCanvas=document.createElement('canvas');grainCanvas.width=grainCanvas.height=256;
    var grainCtx=grainCanvas.getContext('2d'),grainImg=grainCtx.createImageData(256,256);
    for(var gi=0;gi<grainImg.data.length;gi+=4){var gv=112+Math.random()*86;grainImg.data[gi]=grainImg.data[gi+1]=grainImg.data[gi+2]=gv;grainImg.data[gi+3]=255}
    grainCtx.putImageData(grainImg,0,0);
    var grain=new THREE.CanvasTexture(grainCanvas);grain.wrapS=grain.wrapT=THREE.RepeatWrapping;grain.repeat.set(5,2);grain.anisotropy=4;
    upperMat.bumpMap=grain;upperMat.bumpScale=.016;vampMat.bumpMap=grain;vampMat.bumpScale=.016;
    var leather=new THREE.Group(), accents=new THREE.Group(), ornament=new THREE.Group(); group.add(leather,accents,ornament);
    function mesh(g,m,parent){var o=new THREE.Mesh(g,m);o.castShadow=true;o.receiveShadow=true;parent.add(o);return o}
    function shoeFootprint(scale){
      var s=new THREE.Shape();
      s.moveTo(-2.55,-.3); s.bezierCurveTo(-2.58,-.65,-2.32,-.82,-1.72,-.84);
      s.bezierCurveTo(-.78,-.88,.55,-.9,1.55,-.78); s.bezierCurveTo(2.25,-.7,2.62,-.38,2.66,0);
      s.bezierCurveTo(2.62,.38,2.25,.7,1.55,.78); s.bezierCurveTo(.55,.9,-.78,.88,-1.72,.84);
      s.bezierCurveTo(-2.32,.82,-2.58,.65,-2.55,.3); s.bezierCurveTo(-2.5,.08,-2.5,-.08,-2.55,-.3);
      var g=new THREE.ExtrudeGeometry(s,{depth:.12,bevelEnabled:true,bevelSegments:3,steps:1,bevelSize:.035,bevelThickness:.035,curveSegments:16});
      g.rotateX(Math.PI/2); g.scale(scale,1,scale*.76); g.computeVertexNormals(); return g;
    }
    var sole=mesh(shoeFootprint(1),soleMat,group); sole.position.y=.02;
    var welt=mesh(shoeFootprint(.99),weltMat,group); welt.position.y=.14;
    var outsole=mesh(shoeFootprint(.955),liningMat,group); outsole.position.y=-.075;
    function loftGeometry(){
      var N=56,M=40, pos=[],uv=[],idx=[];
      for(var i=0;i<=N;i++){
        var t=i/N,x=-2.37+4.78*t, taper=Math.pow(Math.max(.025,Math.sin(Math.PI*t)),.42),
            width=(.22+.4*Math.sin(Math.PI*Math.pow(t,.78)))*taper,
            bottom=.17, toeFade=t>.78?Math.pow(Math.max(.005,(1-t)/.22),.48):1,
            top=bottom+(.88+.1*Math.sin(Math.PI*Math.pow(t,.8))-.08*t)*toeFade;
        for(var j=0;j<=M;j++){
          var a=2*Math.PI*j/M, sn=Math.sin(a), cs=Math.cos(a), y=bottom+(top-bottom)*(sn*.5+.5), z=width*cs;
          if(sn<-.5)y=bottom+(y-bottom)*.24;
          pos.push(x,y,z); uv.push(t,j/M);
          if(i<N&&j<M){var p=i*(M+1)+j;idx.push(p,p+M+1,p+1,p+1,p+M+1,p+M+2)}
        }
      }
      var g=new THREE.BufferGeometry();g.setAttribute('position',new THREE.Float32BufferAttribute(pos,3));g.setAttribute('uv',new THREE.Float32BufferAttribute(uv,2));g.setIndex(idx);g.computeVertexNormals();return g;
    }
    var upper=mesh(loftGeometry(),upperMat,leather); upper.material.side=THREE.DoubleSide;
    /* Heel stack is built as a shaped, beveled leather block, not a rectangular primitive. */
    function heelShape(){var s=new THREE.Shape();s.moveTo(-2.47,-.52);s.quadraticCurveTo(-2.52,-.61,-2.39,-.63);s.lineTo(-1.65,-.59);s.quadraticCurveTo(-1.56,-.54,-1.6,-.42);s.lineTo(-1.68,-.09);s.quadraticCurveTo(-1.7,.015,-1.82,.015);s.lineTo(-2.34,-.015);s.quadraticCurveTo(-2.48,-.03,-2.47,-.15);s.closePath();return new THREE.ExtrudeGeometry(s,{depth:.82,bevelEnabled:true,bevelSegments:4,bevelSize:.035,bevelThickness:.035})}
    var heel=mesh(heelShape(),soleMat,group);heel.position.z=-.41;
    /* Opening/quarter lining and its rolled collar. */
    var opening=mesh(new THREE.ShapeGeometry((function(){var s=new THREE.Shape();s.absellipse(0,0,.82,.38,0,Math.PI*2,false,0);return s})(),32),liningMat,accents);opening.rotation.x=-Math.PI/2;opening.position.y=1.08;opening.position.x=-.64;
    function tube(points,r,mat,parent){var curve=new THREE.CatmullRomCurve3(points.map(function(p){return new THREE.Vector3(p[0],p[1],p[2])}));return mesh(new THREE.TubeGeometry(curve,Math.max(32,points.length*6),r,8,false),mat,parent)}
    var collar=[];for(var ci=0;ci<=48;ci++){var ca=ci/48*Math.PI*2;collar.push([-.64+Math.cos(ca)*.82,1.09,Math.sin(ca)*.38])}tube(collar,.025,upperMat,accents);
    /* Curved apron seam and fine hand-stitch marks on both sides. */
    var seam=[];for(var si=0;si<=36;si++){var st=si/36,a=st*Math.PI;seam.push([-.12+1.17*Math.cos(a),.86+.04*Math.sin(a),(.48*Math.sin(a))])}tube(seam,.012,stitchMat,accents);
    for(var side=-1;side<=1;side+=2){var sideLine=[];for(var li=0;li<=30;li++){var lt=li/30;sideLine.push([-1.92+2.9*lt,.25+.42*Math.sin(Math.PI*lt),side*(.19+.49*Math.sin(Math.PI*lt))])}tube(sideLine,.012,upperMat,accents);
      for(var si2=0;si2<44;si2++){var q=si2/43, x=-1.65+2.67*q, z=side*(.22+.45*Math.sin(Math.PI*q));var dot=mesh(new THREE.SphereGeometry(.012,8,6),stitchMat,accents);dot.position.set(x,.27+.42*Math.sin(Math.PI*q),z)} }
    /* Gold fisherman knot, laid flat on the vamp. */
    var k1=[];for(var ki=0;ki<=80;ki++){var u=ki/80*Math.PI*2;k1.push([.57+.31*Math.sin(u),1.08+.14*Math.cos(u),.08+.012*Math.sin(2*u)])}tube(k1,.035,goldMat,ornament);
    var k2=[];for(var kj=0;kj<=80;kj++){var v=kj/80*Math.PI*2;k2.push([.86+.3*Math.sin(v),1.08-.14*Math.cos(v),.08-.012*Math.sin(2*v)])}tube(k2,.035,goldMat,ornament);
    tube([[.5,1.12,.08],[.35,1.1,.08],[.24,1.08,.06]],.03,goldMat,ornament);tube([[.93,1.12,.08],[1.08,1.1,.08],[1.19,1.08,.06]],.03,goldMat,ornament);
    var fringe=new THREE.Group();for(var fi=0;fi<7;fi++){var fx=.22+fi*.18;var tass=[];tass.push([fx,1.05,.09],[fx+.012,.78,.1],[fx-.025,.56,.1]);tube(tass,.034,upperMat,fringe);tube([[fx-.04,.82,.12],[fx+.04,.82,.12]],.01,stitchMat,fringe)}group.add(fringe);fringe.visible=false;
    var mono=new THREE.Group();tube([[.68,1.14,.1],[.77,1.14,.1],[.81,1.09,.1],[.76,1.06,.1],[.68,1.06,.1]],.018,goldMat,mono);tube([[.83,1.14,.1],[.93,1.14,.1],[.91,1.06,.1],[.83,1.06,.1]],.018,goldMat,mono);group.add(mono);mono.visible=false;
    var shc=document.createElement('canvas');shc.width=shc.height=256;var shx=shc.getContext('2d'),shg=shx.createRadialGradient(128,128,8,128,128,124);shg.addColorStop(0,'rgba(18,23,35,.25)');shg.addColorStop(.45,'rgba(18,23,35,.11)');shg.addColorStop(1,'rgba(18,23,35,0)');shx.fillStyle=shg;shx.fillRect(0,0,256,256);var shtex=new THREE.CanvasTexture(shc);
    var shadow=new THREE.Mesh(new THREE.PlaneGeometry(5.2,2.8),new THREE.MeshBasicMaterial({map:shtex,transparent:true,depthWrite:false}));shadow.rotation.x=-Math.PI/2;shadow.position.set(.05,-.18,0);scene.add(shadow);
    function resize(){var r=host.getBoundingClientRect(),w=Math.max(1,r.width),h=Math.max(1,r.height);renderer.setSize(w,h,false);camera.aspect=w/h;camera.updateProjectionMatrix()} resize(); window.addEventListener('resize',resize);
    if(typeof ResizeObserver!=='undefined'){var ro=new ResizeObserver(resize);ro.observe(host)}
    THREE_VIEW={update:function(state){var L=find(LEATHERS,state.leather), rubber=state.sole==='borracha';
      upperMat.color.set(L.c);vampMat.color.set(L.c);upperMat.roughness=vampMat.roughness=state.mat==='camurca'?.82:state.mat==='cordovan'?.23:state.mat==='marinho'?.58:.34;
      upperMat.clearcoat=vampMat.clearcoat=state.mat==='camurca'?0:.16;
      soleMat.color.set(rubber?'#292725':'#755c43');weltMat.color.set(rubber?'#292725':'#b79972');outsole.material.color.set(rubber?'#211f1d':'#493728');
      ornament.visible=state.detail==='no';fringe.visible=state.detail==='franja';mono.visible=state.detail==='mono';
    },rotateBy:function(delta){group.rotation.y+=delta},setModel:function(name){group.scale.setScalar(name&&name.toLowerCase().indexOf('reis')>-1?1.015:1)}};
    var selectedModel=document.querySelector('#cfg-model input:checked');
    var modelName=host.getAttribute('data-model')||(selectedModel?selectedModel.getAttribute('data-handle'):'');
    THREE_VIEW.setModel(modelName||'');
    var dragging=false,last=0;
    renderer.domElement.addEventListener('pointerdown',function(e){dragging=true;last=e.clientX;renderer.domElement.setPointerCapture&&renderer.domElement.setPointerCapture(e.pointerId)});
    renderer.domElement.addEventListener('pointermove',function(e){if(dragging){group.rotation.y+=(e.clientX-last)*.012;last=e.clientX}});
    renderer.domElement.addEventListener('pointerup',function(){dragging=false}); renderer.domElement.addEventListener('pointercancel',function(){dragging=false});
    function render(){requestAnimationFrame(render);if(!dragging)group.rotation.y+=.0012;renderer.render(scene,camera)} render();
    THREE_VIEW.update(S); document.getElementById('shoe')&&(document.getElementById('shoe').style.display='none');
  }).catch(function(){if(photoFallback){photoFallback.style.display='block';photoFallback.setAttribute('alt','Fotografia de referência do sapato — pré-visualização 3D indisponível neste dispositivo')}var el=document.getElementById('shoe');if(el)el.style.display='block';});
}
function radios(id,arr,key){
  return arr.map(function(o,i){
    return '<input type="radio" name="'+id+'" id="'+id+i+'"'+(S[key]===o.k?' checked':'')+'>'+
      '<label for="'+id+i+'" data-k="'+o.k+'">'+o.n+(o.add?' +'+o.add+'€':'')+'</label>';
  }).join('');
}
function initCfg(){
  if(!document.getElementById('shoe'))return;
  track('customizer_start',{});
  var lw=document.getElementById('cfg-leather');
  lw.innerHTML=LEATHERS.map(function(l){
    return '<button type="button" class="mat'+(S.leather===l.k?' on':'')+'" data-k="'+l.k+'"><i style="background:linear-gradient(150deg,'+l.c+','+l.s+')"></i><span>'+l.n+(l.add?' +'+l.add+'€':'')+'</span></button>';
  }).join('');
  lw.addEventListener('click',function(e){
    var b=e.target.closest ? e.target.closest('button') : null; if(!b)return;
    S.leather=b.getAttribute('data-k');
    Array.prototype.forEach.call(lw.children,function(c){c.className='mat'+(c===b?' on':'')});
    paint();
  });
  [['cfg-mat',MATS,'mat'],['cfg-sole',SOLES,'sole'],['cfg-detail',DETAILS,'detail']].forEach(function(t){
    var w=document.getElementById(t[0]); if(!w)return;
    w.innerHTML=radios(t[0],t[1],t[2]);
    w.addEventListener('change',function(e){
      var lb=w.querySelector('label[for="'+e.target.id+'"]'); if(lb){S[t[2]]=lb.getAttribute('data-k');paint()}
    });
  });
  var sw=document.getElementById('cfg-size');
  if(sw){
    sw.innerHTML=SIZES.map(function(s,i){return '<input type="radio" name="cfgsize" id="cs'+i+'"><label for="cs'+i+'" data-k="'+s+'">'+s+'</label>'}).join('');
    sw.addEventListener('change',function(e){
      var lb=sw.querySelector('label[for="'+e.target.id+'"]'); if(lb){S.size=lb.getAttribute('data-k');paint()}
    });
  }
  var mw=document.getElementById('cfg-model');
  if(mw){
    var apply=function(inp){
      var model=(inp.getAttribute('data-handle')||'').toLowerCase();
      var detailWrap=document.getElementById('cfg-detail');
      if(model.indexOf('reis')>-1){
        S.leather='bordo';S.detail='gold';
        DETAILS=REIS_DETAILS;
      }else if(model.indexOf('navegante')>-1){
        S.leather='oceano';S.detail='gold';
        DETAILS=NAV_DETAILS;
      }else{DETAILS=[{k:'no',n:'Nó de pescador',add:0},{k:'franja',n:'Franja',add:80},{k:'liso',n:'Liso',add:0},{k:'mono',n:'Monograma gravado',add:160}];S.detail='no'}
      if(detailWrap)detailWrap.innerHTML=radios('cfg-detail',DETAILS,'detail');
      var leatherWrap=document.getElementById('cfg-leather');
      if(leatherWrap)Array.prototype.forEach.call(leatherWrap.querySelectorAll('button'),function(b){b.className='mat'+(b.getAttribute('data-k')===S.leather?' on':'')});
      S.base=parseFloat(inp.getAttribute('data-price')||0);
      var v=document.getElementById('cfgvariant'); if(v)v.value=inp.value;
      if(THREE_VIEW&&THREE_VIEW.setModel)THREE_VIEW.setModel(inp.getAttribute('data-handle')||'');
      paint();
    };
    mw.addEventListener('change',function(e){if(e.target.tagName==='INPUT')apply(e.target)});
    var requested='';
    try{requested=(new URLSearchParams(window.location.search)).get('modelo')||''}catch(e){}
    var selected=null,choices=mw.querySelectorAll('input[data-handle]');
    for(var q=0;q<choices.length;q++)if(choices[q].getAttribute('data-handle')===requested){selected=choices[q];break}
    var first=selected||mw.querySelector('input:checked')||mw.querySelector('input');
    if(first){first.checked=true;apply(first)}
  }
  var f=document.getElementById('cfgform');
  if(f)f.addEventListener('submit',function(e){if(!S.size){e.preventDefault();alert(tr('configurator.choose_size',T.c.choose)||'Choose a size.')}});
  var stage=document.getElementById('shoe-stage');
  if(stage){
    var angle=0,down=false,start=0,from=0;
    var turn=function(v){var prev=angle;angle=Math.max(-28,Math.min(28,v));if(THREE_VIEW&&THREE_VIEW.rotateBy){THREE_VIEW.rotateBy(angle-prev);return}var visual=document.getElementById('shoe');if(visual)visual.style.transform='rotateY('+angle+'deg) rotateX('+(Math.abs(angle)*-.08)+'deg)'};
    stage.addEventListener('pointerdown',function(e){if(e.target.closest&&e.target.closest('button'))return;down=true;start=e.clientX;from=angle;stage.setPointerCapture&&stage.setPointerCapture(e.pointerId)});
    stage.addEventListener('pointermove',function(e){if(down)turn(from+(e.clientX-start)*.18)});
    stage.addEventListener('pointerup',function(){down=false});
    stage.addEventListener('pointercancel',function(){down=false});
    stage.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){turn(angle-8);e.preventDefault()}if(e.key==='ArrowRight'){turn(angle+8);e.preventDefault()}});
    Array.prototype.forEach.call(stage.querySelectorAll('[data-shoe-view]'),function(b){b.addEventListener('click',function(){turn(angle+(b.getAttribute('data-shoe-view')==='left'?-14:14))})});
    turn(0);
  }
  paint();
}

/* ---------- variantes na ficha de produto ---------- */
function initGallery(){
  var g=document.getElementById('gal'); if(!g)return;
  var slides=g.querySelectorAll('.slide'), dots=document.getElementById('galdots'),
      prev=document.getElementById('galprev'), next=document.getElementById('galnext');
  if(slides.length<2){ if(prev)prev.style.display='none'; if(next)next.style.display='none'; if(dots)dots.style.display='none'; return; }
  var html='';
  for(var i=0;i<slides.length;i++)html+='<button type="button" aria-label="Imagem '+(i+1)+'"></button>';
  if(dots)dots.innerHTML=html;
  var idx=0;
  function go(n){ idx=Math.max(0,Math.min(slides.length-1,n)); g.scrollTo({left:g.clientWidth*idx,behavior:'smooth'}); mark(); }
  function mark(){
    if(dots)for(var i=0;i<dots.children.length;i++)dots.children[i].className=(i===idx?'on':'');
    if(prev)prev.disabled=(idx===0);
    if(next)next.disabled=(idx===slides.length-1);
  }
  if(prev)prev.addEventListener('click',function(){go(idx-1)});
  if(next)next.addEventListener('click',function(){go(idx+1)});
  if(dots)dots.addEventListener('click',function(e){
    var k=Array.prototype.indexOf.call(dots.children,e.target); if(k>=0)go(k);
  });
  var t; g.addEventListener('scroll',function(){
    clearTimeout(t); t=setTimeout(function(){ idx=Math.round(g.scrollLeft/g.clientWidth); mark(); },90);
  },{passive:true});
  mark();
}
function initPerso(){
  var sw=document.getElementById('perso-on'), body=document.getElementById('perso-body');
  if(!sw||!body)return;
  if(body.hasAttribute('data-palette-customizer'))return;
  var sync=function(){
    var on=sw.checked; body.hidden=!on;
    var map=[['pcor','p-cor','p-cor-codigo'],['pforro','p-forro','p-forro-codigo'],['psola','p-sola',''],['pdet','p-detalhe','']];
    for(var i=0;i<map.length;i++){
      var c=document.querySelector('input[name="'+map[i][0]+'"]:checked');
      var t=document.getElementById(map[i][1]); if(t)t.value=on&&c?(c.dataset.label||c.value):'';
      var code=document.getElementById(map[i][2]); if(code)code.value=on&&c?(c.dataset.code||''):'';
    }
    var ini=document.getElementById('p-iniciais-in'), it=document.getElementById('p-iniciais');
    if(it)it.value=on&&ini?ini.value.toUpperCase():'';
    if(THREE_VIEW&&on){
      var cv=(document.querySelector('input[name="pcor"]:checked')||{}).value||'';
      var cm={'Cognac':'cognac','Ébano':'ebano','Areia':'areia','Azul-marinho':'oceano','Como na fotografia':'oceano'};
      var sv=(document.querySelector('input[name="psola"]:checked')||{}).value||'';
      var dv=(document.querySelector('input[name="pdet"]:checked')||{}).value||'';
      S.leather=cm[cv]||S.leather; S.sole=sv.indexOf('Borracha')===0?'borracha':'couro'; S.detail=dv.indexOf('Franja')===0?'franja':dv.indexOf('Monograma')===0?'mono':dv.indexOf('Liso')===0?'liso':'no'; THREE_VIEW.update(S);
    }
  };
  sw.addEventListener('change',sync);
  body.addEventListener('change',sync);
  body.addEventListener('input',sync);
  sync();
}
function initProduct(){
  var form=document.querySelector('[data-pform]'); if(!form)return;
  var tag=form.querySelector('[data-variants]'); if(!tag)return;
  var variants=[]; try{variants=JSON.parse(tag.textContent)}catch(e){return}
  var vid=form.querySelector('[data-vid]'), btn=form.querySelector('[data-add]'),
      msg=form.querySelector('[data-msg]'), priceEl=document.querySelector('[data-price]');
  function chosen(){
    return Array.prototype.map.call(form.querySelectorAll('.opts[data-opt]'),function(g){
      var c=g.querySelector('input:checked'); return c?c.value:null;
    });
  }
  function match(){
    var want=chosen();
    for(var i=0;i<variants.length;i++){
      var v=variants[i], ok=true;
      for(var j=0;j<want.length;j++){ if(want[j]!==null && v.options[j]!==want[j]){ok=false;break} }
      if(ok)return v;
    }
    return null;
  }
  function sync(){
    var v=match();
    if(msg){msg.style.display='none';msg.textContent=''}
    if(!v){ if(btn){btn.disabled=true;btn.querySelector('span').textContent=tr('product.unavailable',T.p.unav)||'Unavailable'} return }
    vid.value=v.id;
    if(priceEl)priceEl.textContent=cents(v.price);
    if(btn){
      btn.disabled=!v.available;
      btn.querySelector('span').textContent=v.available?(tr('product.add',T.p.add)||'Add'):(tr('product.sold_out',T.p.sold)||'Sold out');
    }
    if(!v.available && msg){msg.style.display='block';msg.textContent=tr('product.variant_sold_out',T.p.vsold)||''}
  }
  form.addEventListener('change',sync);
  sync();
}

/* ---------- carrinho ---------- */
function renderCart(cart){
  var cn=document.getElementById('cn'); if(cn)cn.textContent=cart.item_count;
  var b=document.getElementById('dbody'), f=document.getElementById('dfoot'); if(!b||!f)return;
  if(!cart.items.length){
    b.innerHTML='<p class="muted" style="text-align:center;padding:80px 0;font-size:13.5px">'+tr('cart.empty',T.cart.empty)+'</p>';
    f.innerHTML='<a class="btn dark block" href="/collections/all"><span>'+tr('cart.see_collection',T.cart.see)+'</span></a>';
    return;
  }
  b.innerHTML=cart.items.map(function(i,idx){
    var props='';
    if(i.properties){for(var k in i.properties){if(i.properties[k])props+='<small>'+k+': '+i.properties[k]+'</small>'}}
    var img=i.image;
    if(!img){
      var h=((i.handle||'')+' '+(i.url||'')+' '+(i.product_title||'')).toLowerCase(), F=window.MDS_FALLBACK||{};
      if(h.indexOf('navegante')>-1)img=F.navegante;
      else if(h.indexOf('reis')>-1)img=F.reis;
      else img=F.generico;
    }
    return '<div class="ln"><div class="im">'+(img?'<img src="'+img+'" alt="">':'')+'</div>'+
      '<div><strong>'+i.product_title+'</strong>'+(i.variant_title&&i.variant_title!=='Default Title'?'<small>'+i.variant_title+'</small>':'')+
      (i.quantity>1?'<small>'+(T._lang==='en'?'Quantity':'Quantidade')+': '+i.quantity+'</small>':'')+props+
      '<small style="color:var(--gold-text)">'+(T._lang==='en'?'Production time confirmed by the atelier':'Prazo de produção confirmado pelo atelier')+'</small>'+
      '<button type="button" data-rm="'+(idx+1)+'">'+tr('cart.remove',T.cart.remove)+'</button></div>'+
      '<div>'+cents(i.final_line_price)+'</div></div>';
  }).join('');
  f.innerHTML='<div class="row"><span>'+tr('cart.subtotal',T.cart.subtotal)+'</span><span>'+cents(cart.total_price)+'</span></div>'+
   '<div class="row"><span>'+(T._lang==='en'?'Production':'Produção')+'</span><span>'+(T._lang==='en'?'Confirmed by the atelier':'A confirmar pelo atelier')+'</span></div>'+'<div class="row"><span>'+tr('cart.shipping',T.cart.shipping)+'</span><span>'+tr('cart.complimentary',T.cart.free)+'</span></div>'+
   '<div class="row t"><span>'+tr('cart.total',T.cart.total)+'</span><span>'+cents(cart.total_price)+'</span></div>'+
   '<a class="btn fill block" href="/checkout"><span>'+tr('cart.checkout',T.cart.checkout)+'</span></a>'+
   '<p class="muted" style="font-size:11.5px;margin-top:16px;text-align:center">'+tr('cart.methods',T.cart.methods)+'</p>';

}
function initCartRemove(){
  var b=document.getElementById('dbody'); if(!b||b.dataset.rmBound)return;
  b.dataset.rmBound='1';
  b.addEventListener('click',function(e){
    var el=e.target.closest ? e.target.closest('[data-rm]') : null;
    if(!el)return;
    e.preventDefault();
    el.disabled=true;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({line:parseInt(el.getAttribute('data-rm'),10),quantity:0})})
      .then(function(r){return r.json()}).then(renderCart)
      .catch(function(){el.disabled=false});
  });
}
function fetchCart(open){
  return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()})
    .then(function(c){renderCart(c); if(open)MDS.openCart(); return c});
}

var MDS={
  mnav:function(o){var m=document.getElementById('mnav'); if(m)m.classList.toggle('on',!!o); document.body.style.overflow=o?'hidden':''},
  openCart:function(){document.getElementById('dr').classList.add('on');document.getElementById('scrim').classList.add('on')},
  closeCart:function(){document.getElementById('dr').classList.remove('on');document.getElementById('scrim').classList.remove('on')},
  closeAll:function(){MDS.closeCart();document.getElementById('md').classList.remove('on');document.getElementById('scrim').classList.remove('on');MDS.mnav(0)},
  modal:function(h){document.getElementById('mb').innerHTML=h;document.getElementById('md').classList.add('on');document.getElementById('scrim').classList.add('on')},
  search:function(open){
    var h=document.getElementById('hdr'); if(!h)return;
    var show = (open===0) ? false : !h.classList.contains('searching');
    h.classList.toggle('searching',show);
    if(show){ var i=h.querySelector('.searchbar input'); if(i)setTimeout(function(){i.focus()},120); }
  },
  guia:function(){
    var rows=[['35','22,3'],['36','23,0'],['37','23,7'],['38','24,4'],['39','25,1'],['40','25,8'],
              ['41','26,5'],['42','27,2'],['43','27,9'],['44','28,6'],['45','29,3']];
    var en=(T._lang==='en');
    var t='<table style="width:100%;border-collapse:collapse;font-size:13.5px;margin:18px 0">'+
      '<tr><th style="text-align:left;padding:0 0 8px;border-bottom:1px solid var(--line);font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:var(--taupe);font-weight:400">'+(en?'Size':'Tamanho')+'</th>'+
      '<th style="text-align:right;padding:0 0 8px;border-bottom:1px solid var(--line);font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:var(--taupe);font-weight:400">'+(en?'Foot length':'Comprimento do pé')+'</th></tr>';
    for(var i=0;i<rows.length;i++){
      t+='<tr><td style="padding:9px 0;border-bottom:1px solid rgba(12,26,60,.07)">'+rows[i][0]+'</td>'+
         '<td style="padding:9px 0;border-bottom:1px solid rgba(12,26,60,.07);text-align:right">'+rows[i][1]+' cm</td></tr>';
    }
    t+='</table>';
    MDS.modal('<h3>'+(en?'Size guide':'Guia de tamanhos')+'</h3>'+
      '<p class="sub-t">'+(en?'Measure at the end of the day, wearing the sock you will use.':'Meça ao fim do dia, com a meia que vai usar.')+'</p>'+
      '<ol style="font-size:13.5px;color:var(--muted);padding-left:18px;line-height:1.9;margin:0 0 6px">'+
      '<li>'+(en?'Place your foot on an A4 sheet against the wall, heel to the wall.':'Pouse o pé numa folha A4 encostada à parede, com o calcanhar na parede.')+'</li>'+
      '<li>'+(en?'Mark the longest toe.':'Marque o dedo mais comprido.')+'</li>'+
      '<li>'+(en?'Measure from wall to mark, in centimetres.':'Meça da parede à marca, em centímetros.')+'</li>'+
      '<li>'+(en?'Repeat on the other foot and use the larger.':'Repita no outro pé e use o maior.')+'</li></ol>'+
      t+
      '<p class="muted" style="font-size:12.5px">'+(en?'Between two sizes, choose the larger. In doubt, write to us — the atelier answers within two working days. Bespoke pieces have no chart: we make to your foot.':'Entre dois tamanhos, escolha o maior. Em caso de dúvida, escreva-nos — o atelier responde em dois dias úteis. Em peças sob medida não há tabela: fazemos ao seu pé.')+'</p>'+
      '<button class="btn dark block" style="margin-top:18px" onclick="MDS.closeAll()">'+(en?'Close':'Fechar')+'</button>');
  },
  appt:function(what){
    track('private_visit_request',{subject:what||'Visita privada'});
    var subj=what?String(what).replace(/"/g,'').replace(/</g,''):'Visita privada';
    MDS.modal('<h3>'+tr('appointment.title',T.a.title)+'</h3><p class="muted" style="margin-bottom:28px">'+tr('appointment.sub',T.a.sub)+'</p>'+
     '<form method="post" action="/contact#contact_form" accept-charset="UTF-8"><input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓">'+
     '<input type="hidden" name="contact[Assunto]" value="'+subj+'">'+
     (what?'<p class="muted" style="font-size:13px;margin-bottom:20px">'+tr('appointment.subject',T.a.subject)+': <b style="color:var(--ink);font-weight:400">'+subj+'</b></p>':'')+
     '<div class="two"><input name="contact[name]" placeholder="'+tr('general.name',T.g.name)+'" required><input name="contact[phone]" placeholder="'+tr('general.phone',T.g.phone)+'"></div>'+
     '<div style="margin-top:20px"><input type="email" name="contact[email]" placeholder="'+tr('general.email',T.g.email)+'" required></div>'+
     '<div class="two" style="margin-top:20px"><input type="date" name="contact[Dia]"><select name="contact[Hora]"><option>10:00</option><option>11:30</option><option>15:00</option><option>16:30</option></select></div>'+
     '<div style="margin-top:20px"><textarea name="contact[body]" placeholder="'+tr('appointment.what',T.a.what)+'"></textarea></div>'+
     '<p class="muted" style="font-size:11.5px;margin:20px 0 24px">'+tr('appointment.note',T.a.note)+'</p>'+
     '<button type="submit" class="btn fill block"><span>'+tr('appointment.cta',T.a.cta)+'</span></button></form>');
  }
};
window.MDS=MDS;

function initVideo(){
  var v=document.getElementById('herovid'), b=document.getElementById('vidplay');
  if(!v){ if(b)b.style.display='none'; return; }
  v.muted=true; v.defaultMuted=true; v.setAttribute('muted','');
  var tryPlay=function(){ var pr=v.play(); if(pr&&pr.catch)pr.catch(function(){}); };
  tryPlay();
  v.addEventListener('loadeddata',tryPlay);
  v.addEventListener('canplay',tryPlay);
  document.addEventListener('touchstart',function once(){tryPlay();document.removeEventListener('touchstart',once)},{passive:true});
  document.addEventListener('visibilitychange',function(){ if(!document.hidden)tryPlay(); });
  if(!b)return;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){try{v.pause()}catch(e){}b.textContent='▶';}
  b.addEventListener('click',function(){
    if(v.paused){v.play();b.textContent='❙❙';b.setAttribute('aria-label','Pausa')}
    else{v.pause();b.textContent='▶';b.setAttribute('aria-label','Reproduzir')}
  });
  v.addEventListener('error',function(){v.style.display='none'});
}
/* ---------- idioma PT / EN ---------- */
var LANG=(function(){try{return localStorage.getItem('mds_lang')||'pt'}catch(e){return 'pt'}})();
function applyLang(l){
  LANG=l;
  try{localStorage.setItem('mds_lang',l)}catch(e){}
  document.documentElement.setAttribute('lang', l==='en'?'en':'pt-PT');
  var bs=document.querySelectorAll('.langsel [data-lang]');
  for(var q=0;q<bs.length;q++){
    bs[q].className=(bs[q].getAttribute('data-lang')==='pt'?'l-pt':'l-en')+(bs[q].getAttribute('data-lang')===l?' on':'');
  }
  var n=document.querySelectorAll('[data-en]');
  for(var i=0;i<n.length;i++){
    var e=n[i];
    if(e.getAttribute('data-pt')===null)e.setAttribute('data-pt',e.innerHTML);
    e.innerHTML = l==='en' ? e.getAttribute('data-en') : e.getAttribute('data-pt');
  }
  var ph=document.querySelectorAll('[data-en-ph]');
  for(var j=0;j<ph.length;j++){
    var x=ph[j];
    if(x.getAttribute('data-pt-ph')===null)x.setAttribute('data-pt-ph',x.placeholder||'');
    x.placeholder = l==='en' ? x.getAttribute('data-en-ph') : x.getAttribute('data-pt-ph');
  }
  T._lang=l;
}
function initLang(){
  applyLang(LANG);
  var bs=document.querySelectorAll('.langsel [data-lang]');
  for(var i=0;i<bs.length;i++){
    bs[i].addEventListener('click',function(){ applyLang(this.getAttribute('data-lang')); });
  }
}
/* ---- Cuidados e reparação: separar as quatro expressões em subtítulos ---- */
function initSubheads(){
  var wrap=document.querySelector('.template-page .rte'); if(!wrap)return;
  var leads=['O número de série','Pedir uma reparação','Cuidados diários','Trocas e devoluções',
             'Your serial number','Request a repair','Everyday care','Exchanges and returns'];
  var ps=wrap.querySelectorAll('p');
  for(var i=0;i<ps.length;i++){
    var p=ps[i], txt=(p.textContent||'').replace(/^\s+/,'');
    for(var k=0;k<leads.length;k++){
      var L=leads[k];
      if(txt.indexOf(L+'.')===0||txt.indexOf(L+':')===0){
        var resto=txt.slice(L.length+1).replace(/^\s+/,'');
        var h=document.createElement('span');
        h.className='sub-head';
        h.textContent=L;
        p.parentNode.insertBefore(h,p);
        p.textContent=resto;
        break;
      }
    }
  }
}
function initForms(){
  document.addEventListener('submit',function(e){
    if(e.defaultPrevented)return;
    var f=e.target;
    if((f.getAttribute('action')||'').indexOf('/cart/add')>-1)return;
    var b=f.querySelector('[type=submit]');
    if(b && !b.disabled){
      var txt=b.textContent;
      b.disabled=true;
      b.setAttribute('data-busy','1');
      setTimeout(function(){ b.disabled=false; b.removeAttribute('data-busy'); }, 6000);
      track('form_submit',{form:(f.querySelector('[name="form_type"]')||{}).value||'generic'});
    }
  },true);
}
/* eventos de analytics — só dispara se houver dataLayer ou gtag */
function track(name,params){
  try{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({event:name}, params||{}));
    if(typeof window.gtag==='function')window.gtag('event',name,params||{});
  }catch(e){}
}
function boot(){
  initSubheads();
  initLang();
  initVideo();
  initPerso();
  initGallery();
  initCartRemove();
  initForms();
  initCfg(); if(document.getElementById('shoe-3d'))init3D('shoe-3d'); if(document.getElementById('product-shoe-3d'))init3D('product-shoe-3d'); initProduct(); fetchCart(false);
  var hero=document.querySelector('main > .hero, main > section > .hero');
  document.body.classList.toggle('has-hero',!!hero);
  var hdr=document.getElementById('hdr');
  var setH=function(){ if(hdr)document.documentElement.style.setProperty('--hdr-h',hdr.offsetHeight+'px'); };
  setH(); window.addEventListener('resize',setH);
  function atTop(){document.body.classList.toggle('at-top',!!hero && window.scrollY<80)}
  atTop(); window.addEventListener('scroll',atTop,{passive:true});
  window.addEventListener('resize',atTop);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){MDS.search(0);MDS.closeAll()}});

  document.addEventListener('submit',function(e){
    var f=e.target;
    var act=(f.getAttribute('action')||'');
    if(act.indexOf('/cart/add')===-1)return;
    e.preventDefault();
    var btn=f.querySelector('[type=submit]'); var old=btn?btn.querySelector('span').textContent:'';
    if(btn){btn.disabled=true;btn.querySelector('span').textContent=tr('product.adding',T.p.adding)||'…'}
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
      .then(function(r){return r.json().then(function(d){return{ok:r.ok,d:d}})})
      .then(function(res){
        if(btn){btn.disabled=false;btn.querySelector('span').textContent=old}
        if(!res.ok){
          var m=f.querySelector('[data-msg]');
          var txt=res.d.description||res.d.message||(tr('product.unavailable',T.p.unav)||'Unavailable');
          if(m){m.style.display='block';m.textContent=txt}else{alert(txt)}
          return;
        }
        track('add_to_cart',{items:[{item_name:(document.querySelector('.buy h1')||{}).textContent||''}]});
        fetchCart(true);
      })
      .catch(function(){ if(btn){btn.disabled=false;btn.querySelector('span').textContent=old} f.submit(); });
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot); else boot();
})();
